import { applySnapshot, Instance, types } from 'mobx-state-tree'
import { storeData } from '../../util/util'

export enum Modes {
  LiveMode = 'Live Mode',
  TestMode = 'Test Mode',
}

export const Mode = types.model('Mode', {
  id: types.string,
  value: types.string,
  url: types.string,
})

const Config = types
  .model('Config', {
    currentMode: types.enumeration(Object.values(Modes)),
    modes: types.array(Mode),
    selectedLanguage: types.optional(types.string, 'English'),
    selectedAppLanguage: types.optional(types.string, 'English'),
  })
  .actions((self) => ({
    setMode(value: string): void {
      const own = { ...self }
      own.currentMode = value === 'Test Mode' ? Modes.TestMode : Modes.LiveMode
      applySnapshot(self, own)
    },
    setSelectedLanguage(selectedLanguage: string): void {
      self.selectedLanguage = selectedLanguage
    },
    updateSelectedAppLanguage(selectedAppLanguage: string): void {
      storeData('SELECTED_LANGUAGE', selectedAppLanguage)
      self.selectedAppLanguage = selectedAppLanguage
    },
  }))
  .views((self) => ({
    getModes(): modeType[] {
      return self.modes
    },
    getMode(): string {
      return self.currentMode
    },
  }))

const configData = Config.create({
  currentMode: Modes.TestMode,
  modes: [
    { id: '1', value: Modes.LiveMode, url: 'http://10.144.25.126:8090/' },
    { id: '2', value: Modes.TestMode, url: 'http://demo8681618.mockable.io/' },
  ],
})

export type modeType = Instance<typeof Mode>
export { Config, configData }
